import React from 'react';

const RebooksUnavailable = () => (
    <div className="table-container">
        <div className="rebooks-unavailable">
            <h1 className="rebooks-unavailable__title">Rebooks</h1>
            <p className="rebooks-unavailable__message">
                We&apos;re currently working on restoring this view.
            </p>
        </div>
    </div>
);

export default RebooksUnavailable;
